export default __webpack_public_path__ + "static/media/a018-4.c56f6743.svg";